import React from 'react';
import DOMPurify from 'dompurify';

interface AppParagraphProps {
  style?: any;
  className?: any;
  noParagraph?: boolean;
  label: any;
}

//chamar o labelsParagraphs nas labels (labelsParagraphs(labels)) antes de usar o AppParagraph para transformar os \r\n em <p>
function AppParagraph(props: AppParagraphProps) {
  return (
    <>
      {!props.noParagraph && (
        <div
          style={props.style}
          className={props.className}
          dangerouslySetInnerHTML={{
            __html: `${DOMPurify.sanitize(props.label)}`,
          }}></div>
      )}
      {props.noParagraph && (
        <span
          style={props.style}
          className={props.className}
          dangerouslySetInnerHTML={{
            __html: `${DOMPurify.sanitize(props.label)}`,
          }}></span>
      )}
    </>
  );
}

export default AppParagraph;
